import { BaseLayoutFactory } from '../components/base-layout-factory';
import PageUnauthorized from './page-unauthorized';

export function PageUnauthorizedFactory() {
    return (
        <BaseLayoutFactory>
            <PageUnauthorized />
        </BaseLayoutFactory>
    );
}
